module.exports = __webpack_public_path__ + "static/img/20.affd18c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/2/20.png
// module id = CAk5
// module chunks = 0